import { useEffect, useState } from 'react';
import '/assets/styles/pages/web-menu-product.scss';

// Partials
import Loader from '/views/partials/loader';
import Btn from '/views/partials/btn';
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Placeholder from '/views/partials/placeholder';
import Pricebox from '/views/partials/pricebox';

// Sections
import WebPageHeader from '/views/sections/web-page-header';

// Services
import menuServices from '/services/menu';

// Context
import { useApplication } from '/utilities/application';
import { useBranchSelection } from '/utilities/branch-selection';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useParams, useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useTranslation } from '/utilities/i18n';

const WebMenuProduct = () => {
	const { isApplication } = useApplication();
	const { redirect } = useNavigator();
	const { branchSlug, id: productId } = useParams('webMenuProduct');
	const { setActiveBranch } = useBranchSelection();
	const { openModal } = useModals();
	const { t } = useTranslation();

	const [product, setProduct] = useState(null);

	useEffect(() => {
		if (productId && branchSlug) {
			menuServices
				.getMenuProduct(productId)
				.then(setProduct)
				.catch((feedback) => {
					openModal('message', { feedback });
				});
		}
	}, [productId, branchSlug]);

	useEffect(() => {
		if (isApplication && productId && branchSlug) {
			setActiveBranch(branchSlug).then(() => {
				redirect('menuProduct', { id: productId });
			});
		}
	}, [branchSlug, productId, isApplication]);

	return (
		<>
			<Loader full solid dark loading={isApplication} />
			<WebPageHeader
				className="product-header"
				backLink={
					branchSlug && product
						? { href: 'webMenuCategory', params: { branchSlug, id: product.category.id } }
						: undefined
				}
				title={product?.category?.title}
				showBranchName
			/>

			{product ? (
				<>
					<div className="product-imagewrap">
						<Img src={product.image} className="product-image" />
					</div>

					<div className="product-titlewrap">
						<div className="wrapper">
							<h1 className="product-title">{product.title}</h1>
							<div className="product-description">{product.description}</div>
						</div>
					</div>

					<Pricebox colored className="product-price" product={product} />

					{!!product.allergen && (
						<div className="product-allergens">
							<div className="wrapper">
								{!!product.allergen?.keywords?.length && (
									<>
										<strong className="allergens-title">{t('Alerjenler')}</strong>
										<ul className="allergens-list">
											{product.allergen.keywords.map((keyword, nth) => (
												<li className="list-keyword" key={nth}>
													<Img className="keyword-image" src={keyword.image} alt={keyword.title} />
												</li>
											))}
										</ul>
									</>
								)}
								{!!product.allergen.description && (
									<div
										className="allergens-description wysiwyg"
										dangerouslySetInnerHTML={{ __html: product.allergen.description }}
									/>
								)}

							</div>

							<div className="product-nutrition">
								<Btn
									className="nude primary hyperlink"
									onClick={() => {
										openModal('productNutritionValues')
									}}>
									{t('Besin Değerleri')}
								</Btn>
							</div>
						</div>
					)}
				</>
			) : (
				<>
					<Placeholder className="product-image" />
					<div className="product-titlewrap">
						<div className="wrapper">
							<Placeholder className="product-title" />
							<Placeholder className="product-description" />
						</div>
					</div>

					<Pricebox colored className="product-price" price={false} />
				</>
			)}
		</>
	);
};

export default WebMenuProduct;
